import styled from 'styled-components';

import { hexToRgba } from '../../../utils/style';
import { Format, BaseStyledComponentProps } from '../../../utils/styles-constants';

interface StyledDropTargetProps extends BaseStyledComponentProps {
	canDrop: boolean;
}

const StyledDropTarget = styled('div')`
	position: absolute;
	top: 25%;
	bottom: 25%;
	left: 0;
	right: 0;
	z-index: -1;

	${({ canDrop, theme }: StyledDropTargetProps) => canDrop && `
		top: 9px;
		bottom: 9px;
		left: 9px;
		right: 9px;
		border-radius: 9px;
		background: ${hexToRgba(theme.primary.actionColor, 25)};
	`}

	@media ${Format.SmartphoneLandscape}, ${Format.Tablet}, ${Format.SmallDesktop}, ${Format.MediumDesktop} {
		top: 9px;
		bottom: 9px;
		left: ${({ canDrop }: StyledDropTargetProps) => canDrop ? '9px' : '25%'};
		right: ${({ canDrop }: StyledDropTargetProps) => canDrop ? '9px' : '25%'};
	}

	.is-dragging & {
		z-index: 11;
	}
`;

const StyledSmallDropTarget = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: -1;
	border-radius: 5px;
	border: ${({ theme }: StyledDropTargetProps) => `1px dashed ${theme.primary.actionColor}`};

	${({ canDrop, theme }: StyledDropTargetProps) => canDrop && `
		background: ${hexToRgba(theme.primary.actionColor, 25)};
		border: none;
	`}

	.is-dragging & {
		z-index: 11;
	}
`;

export {
	StyledDropTarget,
	StyledSmallDropTarget,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/FolderDropTarget/styles.ts